import React from "react";

export class StepperModel {
  constructor(
    public id: string | number,
    public text: string | number,
    public component?: React.ReactElement
  ) {
    this.id = id;
    this.text = text;
    this.component = component;
  }
}
